import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { useState } from "react";
import { Radio, Label } from "theme-ui";
import { pillBoxStyle, pillLabelStyle } from "../../theme/buttons";
const inStockStyling = ({ isSelected, labelClicked }) => ({
    text: pillLabelStyle(isSelected),
    label: Object.assign(Object.assign({}, pillBoxStyle(isSelected)), { ":focus-within": {
            outlineStyle: labelClicked ? "none" : "auto"
        }, "svg, input:checked ~ svg": {
            display: "none"
        } })
});
const outOfStockStyling = ({ isSelected, backgroundColors, labelClicked, disableOutOfStock }) => ({
    text: Object.assign(Object.assign({}, pillLabelStyle(isSelected)), { color: disableOutOfStock ? "grey.2" : isSelected ? "grey.0" : "grey.1", backgroundColor: backgroundColors || ["white", "white", null, "grey.4"], zIndex: 10 }),
    label: Object.assign(Object.assign({}, pillBoxStyle(isSelected)), { cursor: disableOutOfStock ? "not-allowed" : "pointer", ":focus-within": {
            outlineStyle: labelClicked ? "none" : "auto"
        }, backgroundImage: `
              linear-gradient(
                      to left top,
                      rgba(0, 0, 0, 0),
                      rgba(0, 0, 0, 0) 49%,
                      #B3B3B3 calc(49% + 1px),
                      #B3B3B3 51%,
                      rgba(0, 0, 0, 0) calc(51% + 1px),
                      rgba(0, 0, 0, 0)
              );
          `, "svg, input:checked ~ svg": {
            display: "none"
        } })
});
export const SizeButton = ({ isSelected, size, backgroundColors, disableOutOfStock }) => {
    const { isInStock, label, onSelect = () => { } } = size;
    const className = `size-selector-${isInStock ? "in" : "out-of"}-stock`;
    const [labelClicked, setLabelClicked] = useState(false);
    const style = isInStock
        ? inStockStyling({ isSelected, labelClicked })
        : outOfStockStyling({
            isSelected,
            backgroundColors,
            labelClicked,
            disableOutOfStock
        });
    return (_jsxs(Label, { id: `size-selector-${label}`, className: className, onMouseUp: () => setLabelClicked(true), onBlur: () => setLabelClicked(false), sx: style.label, children: [_jsx(Radio, { name: "size-radio", value: "true", defaultChecked: isSelected, disabled: !isInStock && disableOutOfStock, onClick: () => {
                    if (isInStock || !disableOutOfStock) {
                        return onSelect();
                    }
                } }), _jsx("span", { sx: style.text, children: label })] }));
};
//# sourceMappingURL=SizeButton.js.map